var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnRevio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: currentColor;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1,
    y: 3.87,
    width: 21.15,
    height: 41.13
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "21.11 1 25 1 25 4.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.15,
    y1: 34.99,
    x2: 1,
    y2: 34.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1,
    y1: 20.28,
    x2: 22.15,
    y2: 20.28
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnRevio);
export default __webpack_public_path__ + "static/media/icn_revio.f14054dab0a501c30eb54e839fcca381.svg";
export { ForwardRef as ReactComponent };